import React, { useState } from 'react';
import { Link } from 'react-router-dom';

const Header = () => {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
  };

  const closeMobileMenu = () => {
    setIsMobileMenuOpen(false);
  };

  const navigationItems = [
    { to: "/", label: "Home" },
    { to: "/c2pa", label: "C2PA" },
    { to: "/ssai-live", label: "SSAI Live" },
    { to: "/ssai-vod", label: "SSAI VOD" },
    { to: "/ai-quality-enhancement", label: "AI Quality Enhancement" },
    { to: "/live-autocaptioning", label: "Automatic Live Captioning" },
    { to: "/immersive-subtitles", label: "Immersive subtitles" }
  ];

  return (
    <header className="top-menu">
      <div className="flex items-center gap-3 sm:gap-4 md:gap-6 min-w-0 flex-1">
        <Link to="/">
          <img 
            src="/BBM-Logo_line_blue_RGB_BL.svg" 
            alt="BIG BLUE MARBLE logo" 
            className="h-8 sm:h-9 md:h-10 w-auto flex-shrink-0"
          />
        </Link>
        <div className="header-title text-sm sm:text-base md:text-lg font-medium truncate max-w-[50vw] sm:max-w-none">Professional Services Demo</div>
      </div>
      
      {/* Desktop Navigation */}
      <nav className="hidden lg:block">
        <ul>
          {navigationItems.map((item) => (
            <li key={item.to}>
              <Link to={item.to}>{item.label}</Link>
            </li>
          ))}
        </ul>
      </nav>

      {/* Mobile Menu Button */}
      <button 
        className="lg:hidden flex flex-col justify-center items-center w-8 h-8 space-y-1"
        onClick={toggleMobileMenu}
        aria-label="Toggle mobile menu"
      >
        <span 
          className={`block w-6 h-0.5 bg-current transition-all duration-300 ${
            isMobileMenuOpen ? 'rotate-45 translate-y-2' : ''
          }`}
        ></span>
        <span 
          className={`block w-6 h-0.5 bg-current transition-all duration-300 ${
            isMobileMenuOpen ? 'opacity-0' : ''
          }`}
        ></span>
        <span 
          className={`block w-6 h-0.5 bg-current transition-all duration-300 ${
            isMobileMenuOpen ? '-rotate-45 -translate-y-2' : ''
          }`}
        ></span>
      </button>

      {/* Mobile Menu Overlay */}
      {isMobileMenuOpen && (
        <div 
          className="fixed inset-0 bg-black bg-opacity-50 z-40 lg:hidden"
          onClick={closeMobileMenu}
        ></div>
      )}

      {/* Mobile Menu */}
      <nav 
        className={`fixed top-0 right-0 h-full w-64 bg-white shadow-2xl transform transition-transform duration-300 z-50 lg:hidden ${
          isMobileMenuOpen ? 'translate-x-0' : 'translate-x-full'
        }`}
      >
        <div className="p-6">
          {/* Close Button */}
          <button 
            onClick={closeMobileMenu}
            className="absolute top-4 right-4 w-8 h-8 flex items-center justify-center text-gray-600 hover:text-gray-800"
            aria-label="Close mobile menu"
          >
            <span className="text-2xl">&times;</span>
          </button>
          
          {/* Mobile Navigation Items */}
          <ul className="mt-8 space-y-4 flex flex-col">
            {navigationItems.map((item) => (
              <li key={item.to} className="block w-full">
                <Link 
                  to={item.to}
                  onClick={closeMobileMenu}
                  className="block py-3 px-4 text-lg font-medium text-gray-700 hover:text-blue-600 hover:bg-gray-50 rounded-lg transition-colors duration-200 w-full"
                >
                  {item.label}
                </Link>
              </li>
            ))}
          </ul>
        </div>
      </nav>
    </header>
  );
};

export default Header;
